import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-512">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-513">
          {label}
        </label>}
      <input id={inputId} className={`block w-full rounded-lg border-gray-300 border shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 transition-colors ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-514" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-515">{error}</p>}
    </div>;
}